import { MyEquipmentToolTip } from '../my-equipment-tooltip/MyEquipmentTooltip';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatHeading } from '@blocks-react/components/Heading';

type CatToolTipProps = ComponentProps<typeof CatTooltip> & { ariaLabel?: string, label: string };

export const MyEquipmentInfoToolTip: FC<PropsWithChildren<CatToolTipProps>> = ({
  children,
  ariaLabel,
  label = '',
  ...toolTipProps
}) => {
  return (
    <MyEquipmentToolTip {...toolTipProps}>
      <CatButton
        slot="trigger"
        size="sm"
        hideText={true}
        data-testid="tooltip-icon"
        variant='ghost'
      >
        <CatIconInfo slot="after" aria-label={ariaLabel}></CatIconInfo>
      </CatButton>
      <CatHeading variant="footnote">
        {children}
        {label}
      </CatHeading>
    </MyEquipmentToolTip>
  );
};
